import { Component, Renderer2 } from '@angular/core';
import { environment } from '../environments/environment';
import { GlobalService } from './core/services/global.service';
import {
  Router,
  NavigationEnd,
  RouteConfigLoadStart,
  RouteConfigLoadEnd,
} from '@angular/router';
// import { map } from 'src/environments/map';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  previousUrl: string;
  public isNonProd = !environment.production;

  constructor(
    public globalService: GlobalService,
    private renderer: Renderer2,
    public router: Router,
  ) {
    router.events.subscribe((event) => {
      if (event instanceof RouteConfigLoadStart) {
        this.globalService.showLoader = true;
      }
      if (event instanceof RouteConfigLoadEnd) {
        this.globalService.showLoader = false;
      }

      if (event instanceof NavigationEnd) {
        const lastVisitedUrl = window.sessionStorage.getItem('lastVisitedUrl') || '';
        window.sessionStorage.setItem('previousVisitedUrl', lastVisitedUrl);
        window.sessionStorage.setItem('lastVisitedUrl', event.urlAfterRedirects || event.url || '');
      }

      if (this.globalService.getFirstUrlSegment() === '/') {
        this.renderer.removeClass(document.body, 'hotelClass');
      }

      if (this.globalService.getFirstUrlSegment() === 'portal') {
        this.renderer.addClass(document.body, 'hotelClass');
      }
    });
  }

  ngOnInit() {
    this.loadGoogleMaps();
  }

  loadGoogleMaps() {
    const existingScript = document.getElementById('google-maps-script');
    if (!existingScript) {
      const script = this.renderer.createElement('script');
      script.id = 'google-maps-script';
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyAnUrvliRrUgj0GRTwisVkNbJ1I1safq9s&libraries=places&loading=async`;
      script.async = true;
      script.defer = true;

      this.renderer.appendChild(document.head, script);
    }
  }
}
